import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import FrameworkAdminLayout from '../components/FrameworkAdminLayout'
import TemplateDataPage from '../components/templates/TemplateDataPage'
import TemplateDataGridWrapper from '../components/templates/enhance/TemplateDataGridWrapper'
import TemplateDataTabs from '../components/templates/TemplateDataTabs'
import TemplateDataStep from '../components/templates/TemplateDataStep'
import TemplateDataTree from '../components/templates/TemplateDataTree'
import TemplateDataTile from '../components/templates/TemplateDataTile'
import Refresh from '../components/pages/noop/Refresh'
import Portal from '../components/portal'
import baseRouters from './baseRouters'
import pageRouters from './pageRouters'
import routeConfig from '../constants/routeConfig'
import SignPage from '../components/pages/workspace/manager/teaching/schedule/query/sign/qrcode/index'
import GraduateQueryPage from '../components/pages/graduate/query/index'
import GraduateResultPage from '../components/pages/graduate/query/result'

Vue.use(Router)
/* 加载进度 */
NProgress.configure({
  speed: 500,
  showSpinner: false
})

const nodeRoute = [
  {
    path: routeConfig.DataPage.path + ':' + routeConfig.DataPage.param,
    component: TemplateDataPage,
    props: true,
    meta: {
      isolate: true
    }
  }, {
    path: routeConfig.DataGrid.path + ':' + routeConfig.DataGrid.param,
    component: TemplateDataGridWrapper,
    props: true
  }, {
    path: routeConfig.DataTile.path + ':' + routeConfig.DataTile.param,
    component: TemplateDataTile,
    props: true
  }, {
    path: routeConfig.Refresh.path,
    component: Refresh
  },
  ...pageRouters,
  {
    path: 'fragment/:pathMatch(.*)*',
    props: true,
    component: resolve => require(['../components/pages/default/DataFragment'], resolve)
  }
]

const routes = [
  {
    path: '/sign/index',
    component: SignPage
  },
  {
    path: '/graduate/query',
    component: GraduateQueryPage
  },
  {
    path: '/graduate/query/result',
    name: 'GraduateResult',
    component: GraduateResultPage
  },
  {
    path: '',
    component: FrameworkAdminLayout,
    children: [
      {
        path: '',
        redirect: routeConfig.Portal.path
      },
      {
        path: routeConfig.Portal.path,
        component: Portal
      },
      ...nodeRoute,
      {
        path: routeConfig.DataStep.path + ':' + routeConfig.DataStep.param,
        component: TemplateDataStep,
        props: true,
        children: nodeRoute
      },
      {
        path: routeConfig.DataTabs.path + ':' + routeConfig.DataTabs.param,
        component: TemplateDataTabs,
        props: true,
        children: nodeRoute
      },
      {
        path: routeConfig.DataTree.path + ':' + routeConfig.DataTree.param,
        component: TemplateDataTree,
        props: true,
        children: nodeRoute
      }
    ]
  },
  ...baseRouters
]

/**
 * 暂时支持最多两级结构
 * @type {VueRouter}
 */
const router = new Router({
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (!to.matched || to.matched.length === 0) {
    Vue.prototype.$notify.error({
      title: '异常信息',
      message: '页面跳转失败，自动转到首页',
      showClose: false
    })
    next('/')
  } else {
    next()
  }
})

router.beforeResolve((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
